module.exports = __webpack_public_path__ + "static/media/loading-2.f2af1fe8.gif";